<template>
  <Payment :type="3" :id="id"></Payment>
</template>
<script>
import Payment from './components/payment'
export default {
  name: 'Commission',
  components: {Payment},
  data () {
    return {
      id: null,
      parent: null
    }
  },
  created () {},
  mounted () {
    this.id = this.$route.query.id
    this.parent = this.$route.query.parent
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/customer/commission.vue